export default {
  error: {
    type_mismatch: '类型不匹配。',
  },
  validation: {
    invalid: '无效',
    required: '必填',
  },
};
